/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { AuthState, Customer } from './types';
import { MutationRequestStatus } from '../types';

export const mutations: MutationTree<AuthState> = {
  customerLoading(state): void {
    state.customer.error = undefined;
    state.customer.data = undefined;
    state.customer.status = MutationRequestStatus.LOADING;
  },
  customerLoaded(state, customer: Customer) {
    state.customer.error = undefined;
    customer.locale = customer.locale.replace('_', '-');
    state.customer.data = customer;
    state.customer.status = MutationRequestStatus.SUCCESS;
  },
  customerError(state, error) {
    state.customer.error = error;
    state.customer.data = undefined;
    state.customer.status = MutationRequestStatus.ERROR;
  },
};
